<template>
  <div>
    <el-table
    border
      class="banner-table"
      :data="startPageList"
      style="width: 100%"
      :row-key="() => Math.random()"
    >
      <el-table-column prop="confType" label="配置类型" fixed>
        <template slot-scope="scope">
          <span v-if="scope.row.confType=='1'">启动页</span>
          <span v-else-if="scope.row.confType=='2'">广告页</span>
          <span v-else="scope.row.confType=='1'">金刚区</span>
        </template>
      </el-table-column>
      <el-table-column prop="displayName" label="显示名称" width="140p"> </el-table-column>
      <el-table-column prop="platform" align="center" label="平台区分（0是安卓，1是苹果，不填都可用，填一个只能当前平台使用）" width="260p"> </el-table-column>
       <el-table-column  label="app最高版本" width="140p">
        <template slot-scope="scope">
          {{scope.row.verH?scope.row.verH:'--'}}
        </template>
        </el-table-column>
      <el-table-column  label="app最低版本" width="140p">
        <template slot-scope="scope">
          {{scope.row.verL?scope.row.verL:'--'}}
        </template>
      </el-table-column>
      <el-table-column prop="type" label="跳转类型（app内部模块）" width="220p"> </el-table-column>
      <el-table-column prop="confOpen" label="是否开启"> 
         <template slot-scope="scope">
          <el-switch
            :value="scope.row.confOpen"
             @change="handleStatusChange(scope.row, $event)"
            active-color="#13ce66"
            >
          </el-switch>
         </template>
      </el-table-column>
      <el-table-column prop="login" label="是否登录"> 
         <template slot-scope="scope">
          <el-switch
            :value="Boolean(scope.row.login)"
             @change="handleLoginChange(scope.row, $event)"
            active-color="#13ce66"
            >
          </el-switch>
         </template>
      </el-table-column>
      <el-table-column prop="confValue" label="icon" width="140p"> 
         <template slot-scope="scope">
          {{scope.row.confValue[0].icon}}
          
         </template>
      </el-table-column>
      <el-table-column prop="t" label="t" > 
         <template slot-scope="scope">
          {{scope.row.confValue[0].t}}
         </template>
      </el-table-column>
      <el-table-column prop="title" label="title"> 
         <template slot-scope="scope">
          {{scope.row.confValue[0].title}}
         </template>
      </el-table-column>
      <el-table-column prop="url" label="全局地址url" width="120p"> 
         <template slot-scope="scope">
          {{scope.row.confValue[0].url}}
         </template>
      </el-table-column>
      <el-table-column prop="urlAppend" label="相对地址urlAppend" width="160p"> 
         <template slot-scope="scope">
          {{scope.row.confValue[0].urlAppend}}
         </template>
      </el-table-column>
      <!-- <el-table-column prop="type" label="类型">
        <template slot-scope="scope">
          {{
            (
              bannerTypes.find(item => Number(item.type) === scope.row.type) ||
              {}
            ).message
          }}
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="title" label="标题"> </el-table-column>
      <el-table-column label="图片" label-width="200">
        <template slot-scope="scope">
          <image-wrapper
            :src="scope.row.imageUrl"
            width="200px"
          ></image-wrapper>
        </template>
      </el-table-column>
      <el-table-column label="跳转地址">
        <template slot-scope="scope">
          <a :href="scope.row.linkUrl" target="_blank">
            {{ scope.row.linkUrl }}
          </a>
        </template>
      </el-table-column> -->
      <el-table-column label="操作"  fixed="right" width="120p">
        <template slot-scope="scope">
          <el-button
            type="primary"
            circle
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
          ></el-button>
          <el-button
            type="danger"
            circle
            icon="el-icon-delete"
            @click="handleRemove(scope.row.id)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-table
      class="banner-table"
      :data="bannerList"
      :row-key="() => Math.random()"
    >
      <el-table-column prop="__platform" label="平台"> </el-table-column>
      <el-table-column
        prop="__positionType"
        label="广告位置">
      </el-table-column>
      <el-table-column prop="__language" label="语言类型"> </el-table-column>
      <el-table-column prop="type" label="类型">
        <template slot-scope="scope">
          {{
            (
              bannerTypes.find(item => Number(item.type) === scope.row.type) ||
              {}
            ).message
          }}
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题"> </el-table-column>
      <el-table-column label="图片" label-width="200">
        <template slot-scope="scope">
          <image-wrapper
            :src="scope.row.imageUrl"
            width="200px"
          ></image-wrapper>
        </template>
      </el-table-column>
      <el-table-column label="跳转地址">
        <template slot-scope="scope">
          <a :href="scope.row.linkUrl" target="_blank">
            {{ scope.row.linkUrl }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            circle
            icon="el-icon-edit"
            @click="handleUpdate(scope.row.id)"
          ></el-button>
          <el-button
            type="danger"
            circle
            icon="el-icon-delete"
            @click="handleRemove(scope.row.id)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table> -->
    <banner-detail :valueDeatil="detail" @refresh="refreshList"></banner-detail>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import ImageWrapper from 'components/image';
import BannerDetail from '../detail';
import SortableMixin from 'mixins/SortableMixin';
import { async } from 'q';

export default {
  name: 'BannerList',
  mixins: [SortableMixin],
  data() {
    return {
      detail:{},
      bannerId: null,
      sortable: '.banner-table'
    };
  },
  components: {
    ImageWrapper,
    BannerDetail
  },
  computed: {
    ...mapState('startPageSetting', ['bannerTypes','startPageList']),
    ...mapGetters('startPageSetting', ['bannerList'])
  },
  
  methods: {
    ...mapMutations('startPageSetting', ['toggleDetailDialogVisible']),
    ...mapActions('startPageSetting', ['list', 'remove', 'updateSort','delOne','isShowLogin','isOpenSwitch']),
    handleUpdate(row) {
      this.detail=row
      this.toggleDetailDialogVisible(true);
    },
    handleRemove(id) {
      this.$confirm('确认删除此启动页吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          this.delOne(id).then((res) => {
            if(res.code==-1){
              this.$message.error('删除失败，请先关掉配置重试')
            
            }
            if(res.code==0){
            this.$message.success('删除成功！');
            this.$emit('refresh');
           
            }
           
          });
        })
        .catch(() => {});
    },
    onSort(evt) {
      const { oldIndex, newIndex } = evt;
      if (oldIndex !== newIndex) {
        const banner = this.bannerList[oldIndex];

        this.updateSort({
          id: banner.id,
          language: banner.language,
          platform: banner.platform,
          type: banner.type,
          orderNo: newIndex + 1
        }).then(() => {
          this.$message.success('更新成功！');
          // this.$emit('refresh');
        });
      }
    },
     handleStatusChange(row, status) {
      const message = status
        ? "确认要开启当前配置状态吗？"
        : "确认要关当前配置？关闭该配置，相应的选项也将关闭。";

      this.$confirm(message, "提示", { type: "warning" }).then(async() => {
      const res=await  this.isOpenSwitch({id:row.id,confType:row.confType,type:status})
           if(res.code==0){
            this.$emit('refresh');
           }
      });
    },
    handleLoginChange(row, type) {
      const message = type
        ? "确认要开启当前登录状态吗？"
        : "确认要关当前登录？关闭该状态，相应的选项也将关闭。";
     this.$confirm(message, "提示", { type: "warning" }).then(async () => {
   const res=await  this.isShowLogin({id:row.id,type:Number(type)})
      if(res.code==0){
        this.$emit('refresh');
      }
      })
 },
    refreshList() {
      this.$emit('refresh');
    }
   
  }
};
</script>

<style lang="less" scoped>
.image-container{
  padding: 7px;
}
</style>
